import { useState } from 'react';
import PropTypes from 'prop-types';

const Tabs = ({ tabs }) => {

  const [ activeTab, setActiveTab ] = useState(0);

  const handleTabClick = (e) => {
    e.preventDefault();
    const tabIndex = parseInt(e.target.id.split('-')[1], 0);
    if (tabIndex !== activeTab) {
      setActiveTab(tabIndex);
    }
  }

  return (
    <div className="tabs">
      <ul role="tablist" className="tabs__tab_list">
        {
          tabs.map((tab, i) => 
            <li
              key={ `tab_list_item-${i}` }
              className={ `tabs__tab_list_item  ${(i === activeTab) ? `tabs__tab_list_item--active` : null}` }
            >
              <button
                id={ `tab-${i}` }
                type="button"
                role="tab"
                aria-selected={ activeTab === i }
                aria-controls={ `tab_panel-${i}` }
                tabIndex={ activeTab === i ? null : -1 }
                onClick={ handleTabClick }
                className="tabs__tab_button"
              >
                { tab.label }
              </button>
            </li>
          )
        }
      </ul>
      {
        tabs.map((tab, i) => 
          i === activeTab
            ? (
              <div
                key={ `tab_panel-${i}` }
                id={ `tab_panel-${i}` }
                className={ `tabs__tab  ${ (i === activeTab) ? `tabs__tab--active` : `` }`}
                aria-labelledby={ `tab-${i}` }
              >
                { tab.element }
              </div>
            )
            : null
        )
      }
    </div>
  );

}

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.exact({
      label: PropTypes.string.isRequired,
      element: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.arrayOf(PropTypes.node)
      ]).isRequired
    })
  ).isRequired
}

export default Tabs;